import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { typography } = themeVariables;

export const link = css`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: ${palette.blueBase};
  text-decoration: none;
  font-weight: var(${typography.body.fontWeight});
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.lg.fontSize});
  line-height: var(${typography.body.sizes.lg.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;
